module.exports = __webpack_public_path__ + "img/ps.4b36c496.svg";